import { extend } from 'sk-ui/lib/utils/util.js'

import areaIndustryUserForm from './metaData/areaIndustryUserForm'

export default {
  areaIndustryUserCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: areaIndustryUserForm,
      props
    })
  },
  areaIndustryUserEdit({ commit }, params) {
    const props = {
      title: '编辑区域&部门行业人员',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, areaIndustryUserForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
